import {
    CHECK_ACCESS_TYPE_EVENT_DETAIL,
    CHECK_ACCESS_TYPE_EVENT_LIST,
    CHECK_ACCESS_TYPE_GROUP_DETAIL,
    CHECK_ACCESS_TYPE_GROUP_LIST,
    CHECK_ACCESS_TYPE_HOME,
    CHECK_ACCESS_TYPE_MESSENGER,
    CHECK_ACCESS_TYPE_MESSENGER_THREAD,
    CHECK_ACCESS_TYPE_NOTIFICATION,
    CHECK_ACCESS_TYPE_SPORT_VENUE_DETAIL,
    CHECK_ACCESS_TYPE_SPORT_VENUE_LIST,
} from '../../../consts'

/**
 * Get base url from check access API endpoint
 *
 * @param {Object} responseData     - response data from /api/check/access
 * @return {string}
 */
export default responseData => {
    const { REACT_APP_TRANSLATION_ROUTES: translationRoutes } = window.APP_CONFIG
    let link = ''

    switch (responseData?.type) {
        case CHECK_ACCESS_TYPE_HOME:
            link = '/'
            break
        case CHECK_ACCESS_TYPE_EVENT_LIST:
            link = `/${translationRoutes.events}`
            break
        case CHECK_ACCESS_TYPE_EVENT_DETAIL:
            link = `/${translationRoutes.events}/${responseData?.slug}`
            break
        case CHECK_ACCESS_TYPE_GROUP_LIST:
            link = `/${translationRoutes.clubs}`
            break
        case CHECK_ACCESS_TYPE_GROUP_DETAIL:
            link = `/${translationRoutes.clubs}/${responseData?.slug}`
            break
        case CHECK_ACCESS_TYPE_SPORT_VENUE_LIST:
            link = `/${translationRoutes.sportVenues}`
            break
        case CHECK_ACCESS_TYPE_SPORT_VENUE_DETAIL:
            link = `/${translationRoutes.sportVenues}/${responseData?.slug}`
            break
        case CHECK_ACCESS_TYPE_NOTIFICATION:
            link = `/${translationRoutes.notifications}`
            break
        case CHECK_ACCESS_TYPE_MESSENGER:
            link = `/${translationRoutes.chat}`
            break
        case CHECK_ACCESS_TYPE_MESSENGER_THREAD:
            link = `/${translationRoutes.chat}/t/${responseData?.slug}`
            break
    }

    if (responseData?.subtype) {
        link = `${link}${responseData?.url?.split?.(responseData?.slug)?.[1]}`
    }

    return link
}
